import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AnimatePresence, motion } from 'framer-motion';
import { Menu as MenuIcon, X } from 'lucide-react';

const Menu = ({ temaActual, onChangeLanguage, onNavigateToProjects, onNavigateToSection }) => {
  const { t, i18n } = useTranslation();
  const [menuAbierto, setMenuAbierto] = useState(false);

  const navegarASeccion = (sectionId) => {
    setMenuAbierto(false);
    onNavigateToSection(sectionId);
  };

  const navegarAProyectos = () => {
    setMenuAbierto(false);
    onNavigateToProjects();
  };

  const links = [
    { label: t('navigation.services'), onClick: () => navegarASeccion('que-hacemos') },
    { label: t('navigation.history'), onClick: () => navegarASeccion('historia') },
    { label: t('navigation.projects'), onClick: navegarAProyectos },
    { label: t('navigation.contact'), onClick: () => navegarASeccion('contacto') }
  ];

  return (
    <header className={`fixed left-0 right-0 top-0 z-50 border-b ${temaActual.bg} ${temaActual.border} shadow-lg backdrop-blur-md`}>
      <div className="container mx-auto flex items-center justify-between px-4 py-4">
        <button
          type="button"
          className="flex cursor-pointer items-center gap-3 text-left"
          onClick={() => navegarASeccion('inicio')}
        >
          <img
            src="/logo.png"
            alt="Logo de Cropsbreed SA"
            className="h-12 w-12 object-contain"
          />
          <span className="brand-wordmark text-2xl text-black">
            <span className="font-bold">CROPSBREED</span>{' '}
            <span className="font-normal">SA</span>
          </span>
        </button>

        <nav className="hidden items-center gap-6 md:flex" aria-label={t('footer.navigation')}>
          {links.map((link) => (
            <button
              key={link.label}
              type="button"
              onClick={link.onClick}
              className="text-sm font-medium text-gray-600 transition-colors hover:text-blue-600"
            >
              {link.label}
            </button>
          ))}
        </nav>

        <div role="group" aria-label={t('language.label')} className="flex items-center rounded-md border border-gray-300 p-1">
          <button
            type="button"
            onClick={() => onChangeLanguage('es')}
            aria-label={t('language.spanish')}
            aria-pressed={i18n.language === 'es'}
            title={t('language.spanish')}
            className={`rounded px-2 py-1 text-xs font-bold transition-colors ${i18n.language === 'es' ? `${temaActual.accentBg} text-white` : 'text-gray-600 hover:bg-gray-100'}`}
          >
            ES
          </button>
          <button
            type="button"
            onClick={() => onChangeLanguage('en')}
            aria-label={t('language.english')}
            aria-pressed={i18n.language === 'en'}
            title={t('language.english')}
            className={`rounded px-2 py-1 text-xs font-bold transition-colors ${i18n.language === 'en' ? `${temaActual.accentBg} text-white` : 'text-gray-600 hover:bg-gray-100'}`}
          >
            EN
          </button>
        </div>

        <button
          type="button"
          onClick={() => setMenuAbierto(!menuAbierto)}
          aria-label={menuAbierto ? t('navigation.closeMenu') : t('navigation.openMenu')}
          aria-expanded={menuAbierto}
          className="rounded-lg p-2 transition-colors hover:bg-gray-100 md:hidden"
        >
          {menuAbierto ? <X className="h-6 w-6" /> : <MenuIcon className="h-6 w-6" />}
        </button>
      </div>

      <AnimatePresence>
        {menuAbierto && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className={`overflow-hidden border-t ${temaActual.bg} ${temaActual.border} md:hidden`}
          >
            <nav aria-label={t('footer.navigation')} className="container mx-auto flex flex-col gap-3 px-4 py-4">
              {links.map((link) => (
                <button
                  key={link.label}
                  type="button"
                  onClick={link.onClick}
                  className="w-full border-b border-gray-100 py-2 text-left text-sm font-medium text-gray-600 transition-colors hover:text-blue-600"
                >
                  {link.label}
                </button>
              ))}
            </nav>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Menu;
